const GlobalLocalToken = "usertoken";
const GlobalLocalUserMsg = "userInfo";
const GlobalStatusList = [
  {
    value: -1,
    label: "编辑中",
  },
  {
    value: 0,
    label: "解析中",
    color: "#4090FF",
    backgroundColor: "#80b5ff1a",
  },
  {
    value: 1,
    label: "解析完成",
    color: "rgba(86, 192, 141, 1)",
    backgroundColor: "#56c08d1a",
  },
  {
    value: 2,
    label: "解析错误",
    color: "rgba(247, 101, 96, 1)",
    backgroundColor: "#f765601a",
  },
];
const GlobalLevelList = [
  {
    value: 0,
    label: "符合标准",
    color: "#165DFF",
  },
  {
    value: 2,
    label: "还能提高",
    color: "#E6A23C",
  },
  {
    value: 1,
    label: "急需改正",
    color: "#F53F3F",
  },
];

const GlobalScoreSection = [50, 80]
const GlobalLocalCacheUrlList = 'GlobalLocalCacheUrlList';
const GlobalLocalLeaveUrl = 'GlobalLocalLeaveUrl'

export default {
  GlobalLocalToken,
  GlobalLocalUserMsg,
  GlobalStatusList,
  GlobalLevelList,
  GlobalScoreSection,
  GlobalLocalCacheUrlList,
  GlobalLocalLeaveUrl
};
